import { useLayoutEffect } from 'react';
import native from '../services/NativeBackgroundPositionService';

// No Start/enrollment/permission prompt from auth observation. Native compares
// login first, stopping different sessions synchronously inside its IPC method;
// same-session WebView recovery may leave the independent FGS running.
export default function useNativeBackgroundPosition({ loaded, signedIn, login, owner }) {
  useLayoutEffect(() => {
    if (!loaded) return;
    const authenticatedLogin = signedIn ? login : null;
    void native.observeLogin(authenticatedLogin).catch(() => {});
    if (authenticatedLogin && owner) void native.bind(owner, authenticatedLogin).catch(() => {});
    // Deliberately no unmount detach: WebView lifetime isn't collector lifetime.
  }, [loaded, signedIn, login, owner]);
}
